import AEMWrapper from "aem/ComponentWrapper";
import meta from "./aem-meta";
import loadable from "@loadable/component";
import React from "react";

const Component = loadable(
  () => import(/* webpackChunkName: "component-text-custom" */ "."),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component);
